import { api } from '@/lib/api-client';
import type { PlayerDto } from '@/models/players';

export const PlayerService = {
  async getPlayer(playerId: string): Promise<PlayerDto> {
    const response = await api.get<PlayerDto>(`/v1/player/${playerId}`);
    return response.data;
  },
};
